<template>
  <div class="card" v-on:click="onClick(painting.id)">
    <img
      :src="require(`@/assets/images/${painting.imageName}`)"
    />
    <div class="container">
      <h4>
        <b>{{ painting.title }}</b>
      </h4>
      <p>{{ painting.description }}</p>
    </div>
  </div>
</template>

<script>
import router from '@/Router.vue';

export default {
  setup() {},

  props: {
    painting: Object,
  },
  methods: {
    onClick(id) {
      router.push(`/painting/${id}`);
    },
  },
};
</script>

<style scoped>
.card {
  transition: 0.3s;
  width: 350px;
  margin: 20px;
  background-color: whitesmoke;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.card:hover {
  box-shadow: 0 10px 25px 5px rgba(0, 0, 0, 0.4);
}

img {
  width: 100%;
  height: 450px;
  object-fit: cover;
  transition: all 0.3s;
}
img:hover {
  width: 100%;
  filter: contrast(120%) sepia(30%);
}

.container {
  padding: 2px 16px;
}
</style>
